import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-surface group-[.toaster]:text-foreground group-[.toaster]:border-border-strong group-[.toaster]:shadow-lg group-[.toaster]:gap-3',
          title: 'group-[.toast]:text-sm group-[.toast]:font-medium',
          description: '!text-foreground-subtle !text-xs',
          actionButton: '!bg-secondary-active !text-foreground !cursor-default',
          cancelButton:
            '!bg-secondary-active !text-foreground-muted !cursor-default',
          closeButton:
            '!bg-secondary !hover:bg-secondary-hover !border-border-strongest !text-foreground !cursor-default',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
